(function(){
  var nav=document.getElementById('bs-nav');
  if(nav){
    var burger=nav.querySelector('.bs-nav__burger');
    if(burger){
      burger.addEventListener('click',function(){
        var open=nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded',open);
        document.documentElement.classList.toggle(
          'bs-mobile-overlay-open',
          window.matchMedia('(max-width: 880px)').matches && open
        );
        markFixedThirdPartyLaunchers();
      });
    }
    nav.querySelectorAll('.bs-nav__links a').forEach(function(a){
      a.addEventListener('click',function(){nav.classList.remove('is-open');});
    });
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});
    },{threshold:.12});
    document.querySelectorAll('.bs-reveal').forEach(function(el){io.observe(el);});
  }else{
    document.querySelectorAll('.bs-reveal').forEach(function(el){el.classList.add('is-in');});
  }

  var launcherSelector=[
    '[id*="smile" i],[class*="smile" i]',
    '[id*="loyal" i],[class*="loyal" i]',
    '[id*="reward" i],[class*="reward" i]',
    '#launcher-wrapper,.ba-loy-circle',
    '[id*="rivo" i],[class*="rivo" i],iframe[src*="rivo" i]',
    '[id*="growave" i],[class*="growave" i]',
    '[id*="yotpo-swell" i],[class*="yotpo-swell" i]',
    '[id*="judgeme" i],[class*="judgeme" i],[id*="jdgm" i],[class*="jdgm" i],iframe[src*="judgeme" i]'
  ].join(',');
  function markFixedThirdPartyLaunchers(){
    document.querySelectorAll(launcherSelector).forEach(function(el){
      if(el === document.body || el === document.documentElement) return;
      if(window.getComputedStyle(el).position === 'fixed'){
        el.classList.add('bs-third-party-launcher');
        if(
          el.parentElement &&
          el.parentElement !== document.body &&
          el.parentElement !== document.documentElement
        ){
          el.parentElement.classList.add('bs-third-party-launcher');
        }
      }
    });
  }
  function syncMobilePurchaseMode(){
    var isMobile=window.matchMedia('(max-width: 880px)').matches;
    var sticky=document.querySelector('.bs-sticky-atc:not([hidden])');
    var drawer=document.querySelector('cart-drawer[open], cart-drawer.is-open, .drawer.is-open, .drawer.active');
    document.documentElement.classList.toggle('bs-mobile-purchase-mode',isMobile && !!(sticky || drawer));
    document.documentElement.classList.toggle('bs-mobile-overlay-open',isMobile && !!(nav && nav.classList.contains('is-open')));
    markFixedThirdPartyLaunchers();
  }
  var refreshTimer;
  function schedulePurchaseModeSync(){
    window.clearTimeout(refreshTimer);
    refreshTimer=window.setTimeout(syncMobilePurchaseMode,80);
  }
  if(window.MutationObserver){
    new MutationObserver(function(mutations){
      var needsSync=mutations.some(function(mutation){
        if(mutation.type === 'childList') return mutation.addedNodes.length > 0;
        return mutation.target.matches && mutation.target.matches('.bs-sticky-atc, cart-drawer, .drawer');
      });
      if(needsSync) schedulePurchaseModeSync();
    }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class','hidden','open']});
  }
  window.addEventListener('resize',syncMobilePurchaseMode);

  function syncCustomCartCount(cartData){
    if(!cartData || typeof cartData.item_count !== 'number') return;
    document.querySelectorAll('[data-bs-cart-count]').forEach(function(el){
      el.textContent=cartData.item_count;
    });
  }
  if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate){
    subscribe(PUB_SUB_EVENTS.cartUpdate,function(event){
      syncCustomCartCount(event && event.cartData);
    });
  }
  syncMobilePurchaseMode();
})();

document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches('form[action^="/cart/add"]')) return;
    form.querySelectorAll('textarea[name="properties[Gift Message]"]').forEach(function(field) {
      if (!field.value.trim()) field.removeAttribute('name');
    });
  }, true);
